import { WidgetAutocheck } from "@redotech/redo-model/widget";
import {
  ExtensionShopifyClient,
  ShopifyAjaxClient,
} from "@redotech/shopify-client/ajax";
import { TapcartClient } from "../shopify";
import { getStorefrontAccessToken } from "../utils";
import { BigcommerceStorefrontClient } from "./bigcommerce-storefront";
import { CommercecloudStorefrontClient } from "./commercecloud-storefront";
import { StorefrontClient } from "./storefront";

export interface CreateExtensionShopifyClientOptions {
  autocheck: WidgetAutocheck;
  onTapcart: boolean;
}

export async function createExtensionShopifyClient(
  autocheck: WidgetAutocheck,
  onTapcart: boolean,
): Promise<ExtensionShopifyClient> {
  if (globalThis.redoStorefront?.type === "bigcommerce") {
    return new BigcommerceStorefrontClient({
      storeUrl: globalThis.redoStorefront.storeUrl!,
      auth: getStorefrontAccessToken(autocheck),
    });
  } else if (globalThis.redoStorefront?.type === "commercecloud") {
    return new CommercecloudStorefrontClient({
      storeUrl: globalThis.redoStorefront.storeUrl!,
      locale: "en_AU",
    });
  } else if (onTapcart) {
    return new TapcartClient(
      getStorefrontAccessToken(autocheck),
      (globalThis as any).STORE_URL,
      globalThis.Tapcart!,
    );
  } else if (
    globalThis.Shopify?.Checkout?.apiHost == "denim-tears.myshopify.com"
  ) {
    return new StorefrontClient(
      "denim-tears.myshopify.com",
      getStorefrontAccessToken(autocheck),
      globalThis?.Shopify?.Checkout?.cartToken ||
        (await ShopifyAjaxClient.fromEnv().cartGet()).token!,
    );
  } else if (
    globalThis.Shopify?.Checkout?.apiHost == "ensorings.myshopify.com"
  ) {
    return new StorefrontClient(
      "ensorings.myshopify.com",
      getStorefrontAccessToken(autocheck),
      globalThis?.Shopify?.Checkout?.cartToken ||
        (await ShopifyAjaxClient.fromEnv().cartGet()).token!,
    );
  } else {
    return ShopifyAjaxClient.fromEnv();
  }
}
